import { RequestProvider } from '@/shared/providers/request.provider';
import { ErrorProvider } from '@/shared/providers/errors.provider';
import { SUBSTITUTE_TEACHER_API } from '../values/substitute-teacher.values';
import { API_VARIABLES } from '../values/substitute-teacher.values';
import { GetSubstituteTeacherParams, CreateSubstituteTeacherParams } from '../interfaces/substitute-teacher-params.interface';

class SubstituteTeacherServiceClass {

  /* Get Methods */
  getSubstituteTeachersByType(data: GetSubstituteTeacherParams){
    try {
      let req = SUBSTITUTE_TEACHER_API.GET_SUBSTITUTE_TEACHERS.replace(API_VARIABLES.TYPE, data.type.toString());
      let body = {
        page: data.page,
        pageSize: data.pageSize
      }
      return RequestProvider.get(req, body)
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  getAvailableClasses(organizationId: number) {
    try {
      let req = SUBSTITUTE_TEACHER_API.GET_AVAILABLE_CLASSES;
      return RequestProvider.get(req, {organizationId});
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  getPendingInvitations() {
    try {
      let req = SUBSTITUTE_TEACHER_API.GET_PENDING_RECEIVED_INVITATIONS;
      return RequestProvider.get(req)
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  /* Post Methods */
  async createSubstituteTeacher(data: CreateSubstituteTeacherParams){
    try {
      let req = SUBSTITUTE_TEACHER_API.CREATE_SUBSTITUTE_TEACHER
      let body = {
        organizationId :data.organizationId,
        canEdit: data.canEdit,
        canGrade: data.canGrade,
        classesIds: data.classesIds,
        startDate: data.startDate,
        endDate: data.endDate,
        substituteEmail: data.substituteEmail
      }
      return await RequestProvider.post(req, body)
    } catch (err) {
      throw err.data
    }
  }

  acceptRejectTeacherInvitation(status: string, substituteTeacherId: number){
    try {
      let req = SUBSTITUTE_TEACHER_API.ACCEPT_REJECT_TEACHER_INVITATION
        .replace(API_VARIABLES.SUBSTITUTE_TEACHER_ID, substituteTeacherId.toString());
      return RequestProvider.post(req, null, {status})
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  /* Put Methods */
  async updateTeacherInvitation(data: CreateSubstituteTeacherParams, substituteTeacherId: number){
    try {
      let req = SUBSTITUTE_TEACHER_API.UPDATE_DELETE_TEACHER_INVITATION
        .replace(API_VARIABLES.SUBSTITUTE_TEACHER_ID, substituteTeacherId.toString());
      let body = {
        organizationId :data.organizationId,
        canEdit: data.canEdit,
        canGrade: data.canGrade,
        classesIds: data.classesIds,
        startDate: data.startDate,
        endDate: data.endDate,
        substituteEmail: data.substituteEmail
      }
      return await RequestProvider.put(req, body)
    } catch (err) {
      throw err.data
    }
  }

  /* Delete Methods */
  deleteTeacherInvitation(substituteTeacherId: number) {
    try {
      let req = SUBSTITUTE_TEACHER_API.UPDATE_DELETE_TEACHER_INVITATION
        .replace(API_VARIABLES.SUBSTITUTE_TEACHER_ID, substituteTeacherId.toString());
      return RequestProvider.remove(req)
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }
}

export const SubstituteTeacherService = new SubstituteTeacherServiceClass();